import { render, staticRenderFns } from "./stationTabContent.vue?vue&type=template&id=489855a8&"
import script from "./stationTabContent.vue?vue&type=script&lang=js&"
export * from "./stationTabContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports